import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Markup, MarkupProps } from './Markup';

export interface StandaloneMarkupProps extends StandaloneComponentProps<typeof Markup> {
  markup?: MarkupProps['markup'];
}

export const StandaloneMarkup: StandaloneComponent<StandaloneMarkupProps> = ({ markup, options, ...props }) => {
  return <Markup {...{ markup }} {...options} {...props} />;
};

export default StandaloneMarkup;
